export const PAYMENT_TIMEOUT_KEY_PREFIX = "payment_timeout_";

export const PaymentTimeoutService = {
  setTimedOut(invoiceId: string): void {
    localStorage.setItem(
      `${PAYMENT_TIMEOUT_KEY_PREFIX}${invoiceId}`,
      JSON.stringify({ timedOutAt: Date.now() })
    );
  },

  clearTimedOut(invoiceId: string): void {
    localStorage.removeItem(`${PAYMENT_TIMEOUT_KEY_PREFIX}${invoiceId}`);
  },

  isTimedOut(invoiceId: string): boolean {
    return !!localStorage.getItem(`${PAYMENT_TIMEOUT_KEY_PREFIX}${invoiceId}`);
  },
};

export const clearPaymentTimeout = (key: string) => {
  localStorage.removeItem(key);
  window.dispatchEvent(new CustomEvent("paymentExpired", { detail: { key } }));
};